import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=b8ef571e&scoped=true&"
import script from "./ImportFile.vue?vue&type=script&lang=ts&"
export * from "./ImportFile.vue?vue&type=script&lang=ts&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=b8ef571e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ef571e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b8ef571e', component.options)
    } else {
      api.reload('b8ef571e', component.options)
    }
    module.hot.accept("./ImportFile.vue?vue&type=template&id=b8ef571e&scoped=true&", function () {
      api.rerender('b8ef571e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImportFile.vue"
export default component.exports